import { Navigate, useLocation } from "react-router-dom";
import { isChatEntry } from "@/config/chat.config";
import type { ChatEntry } from "@/types/chat";

/** Preserves `location.state` when moving legacy `/chat` links to `/` or `/mentor`. */
export const ChatLegacyRedirect = () => {
  const location = useLocation();
  const raw = (location.state as { entry?: unknown } | null)?.entry;
  const entry: ChatEntry = isChatEntry(raw) ? raw : "ai_mentor";
  const to = entry === "ai_mentor" ? "/" : "/mentor";
  return <Navigate to={to} replace state={location.state} />;
};
